import { START_REQUEST, END_REQUEST } from './actionsTypes';

export const startRequest = () => {
  return { type: START_REQUEST, payload: true }
};

export const endRequest = () => {
  return { type: END_REQUEST, payload: false }
};




// WEBPACK FOOTER //
// ./src/actions/loading.js